import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_range_filter = _resolveComponent("date-range-filter")!
  const _component_LabelFilterBtn = _resolveComponent("LabelFilterBtn")!
  const _component_PersonsSidebarBtn = _resolveComponent("PersonsSidebarBtn")!
  const _component_posts_toolbar = _resolveComponent("posts-toolbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_posts_toolbar, {
      filters: _ctx.filters,
      minimized: _ctx.minimized,
      "maximize-btn": _ctx.maximizeBtn,
      "onUpdate:filters": _ctx.onFiltersUpdate
    }, {
      append: _withCtx(() => [
        _createVNode(_component_LabelFilterBtn, {
          "client-id": _ctx.client.id,
          "model-value": _ctx.labelSelection,
          "onUpdate:modelValue": _ctx.onLabelSelectionChange
        }, null, 8, ["client-id", "model-value", "onUpdate:modelValue"]),
        _createVNode(_component_PersonsSidebarBtn, {
          "client-id": _ctx.client.id,
          "person-ids": _ctx.personIds,
          "onUpdate:personIds": _ctx.onPersonIdsChange
        }, null, 8, ["client-id", "person-ids", "onUpdate:personIds"])
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        ((_ctx.filters.socialSiteIds || []).length)
          ? (_openBlock(), _createBlock(_component_date_range_filter, {
              key: 0,
              "client-id": _ctx.client.id,
              "date-of-loss": _ctx.client.dateOfLoss,
              "model-value": _ctx.range,
              filters: _ctx.filters,
              "onUpdate:modelValue": _ctx.selectRange
            }, null, 8, ["client-id", "date-of-loss", "model-value", "filters", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["filters", "minimized", "maximize-btn", "onUpdate:filters"])
  ]))
}